import { FC } from 'react';
import PageItemWrapper from '../page-item-wrapper/page-item-wrapper';
import IconNextPage from '../../../../../icons/icon-next-page/icon-next-page';
import Button from '../button/button';
import { IPaginationButtonProps } from '../../../../table.types';
import Icon from '../../../../../icons/icon/icon';

const Last: FC<IPaginationButtonProps> = ({ onClick, isActive }) => {
    return (
        <PageItemWrapper classList={['last']}>
            {isActive ? (
                <Button onClick={onClick} label="Last »">
                    <Icon Component={IconNextPage} />
                    <Icon Component={IconNextPage} />
                </Button>) : <span className="page-link" aria-disabled="true">
                <Icon Component={IconNextPage} disabled />
                <Icon Component={IconNextPage} disabled />
            </span>
            }

        </PageItemWrapper>
    )
}

export default Last;
